import { Router } from '@angular/router';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
/**
 * Services Imports.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { ImageGroupService } from './../../dataservices/master-service/image-group.service';
import { DataStorageService } from './../../dataservices/data-storage.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
/**
 * Import constants.
 */
import { PRODUCT_TYPE_CONSTANT, MEDIA_TYPE, SCREEN_NAME, NUMBERS, ACTION_TYPE, PRODUCT_TYPE_NUMBER_MAPPING, PRODUCT_TYPE_CONSTANT_NAME, CTA_TYPE, ACTION_ON } from './../../constants/app.constants';
/**
 * Import Model.
 */
import { EcSlideCards, UserProfile, Channel } from '../../interface/editors-choice/editors-choice.model';
import { HashTagSpecialty } from './../../interface/hashtag-specialty/hashtag-specialty.model';
import { Analytics } from 'analytics2.0';
import { CLICK_SUB } from 'analytics2.0/dist/core/constants/analytic.interface';

/**
 * Cards component which are loaded inside Editors choice card.
 */
@Component({
  selector: 'app-editor-choice-highlights',
  templateUrl: './editor-choice-highlights.component.html',
  styleUrls: ['./editor-choice-highlights.component.scss']
})
export class EditorChoiceHighlightsComponent implements OnInit {
  /**
   * Input used to get data inside the card where it is called.
   */
  @Input() editorChoiceSlideContent: EcSlideCards;

  @Input() ecId: number;

  @Input() callingfrom: string;
  /**
   * Output is used to emit editor choice specialty in card.
   */
  @Output() feedSpecialty: EventEmitter<HashTagSpecialty> = new EventEmitter<HashTagSpecialty>();
  /**
   * Product type constants.
   */
  public productType = PRODUCT_TYPE_CONSTANT;
  public mediaType = MEDIA_TYPE;

  /**
   * Constant for numbers
   */
  public numbers = NUMBERS;

  /**
   * Necessary instance.
   */
  constructor(
    public igs: ImageGroupService,
    public nls: NewLanguageService,
    private dss: DataStorageService,
    private fcs: FunCollectionService,
    private analyticSdk: Analytics,
    private router: Router) { }

  ngOnInit(): void {
  }

  /**
   * Get specialty aligned with feed.
   */
  getSpecialty(specialty): void {
    this.feedSpecialty.emit(specialty);
    this.dss.specialty_filter = specialty;
    this.router.navigate(['/web/list']);
  }

  navigateToUser(userData: UserProfile): void {
    this.fcs.navigateToUserProfie(userData.custom_id);
  }

  navigateToChannel(ChannelData: Channel): void {
    this.fcs.navigateToChannelDetail(ChannelData.channel_id);
  }

  setAnalyticsSdkObjectOnClick(actionOn: string, ctaType: string): void {
    const clickSub: CLICK_SUB = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR,
      entity_code: this.ecId,
      sub_entity_type: PRODUCT_TYPE_NUMBER_MAPPING[this.editorChoiceSlideContent.product_type],
      sub_entity_code: this.editorChoiceSlideContent.product_type_id,
      current_screen_name: this.fcs.currentScreename,
      action_on: actionOn,
      action_type: ACTION_TYPE.CLICK,
      cta_type: CTA_TYPE.SUB_CARD,
      rank: null,
      start_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.CLICK_SUB(clickSub);
  }

}
